export enum PaymentType {
  CreditCard = 'Credit Card',
  Check = 'Check',
  PurchaseOrder = 'Purchase Order',
}
